import React, { forwardRef, useState } from "react";
import { FormLabel, IconButton, InputAdornment, TextField } from "@mui/material";
import { Visibility, VisibilityOff } from "@mui/icons-material";
import { inputStyles as styles } from "./inputField.style";

const InputField = forwardRef(({
    label, // Input Label, aria-label
    name, // Input name, id(if not provided)
    error, // Is there Error? (true/ false)
    helperText, // Helper Text
    showLabel, // Show Label or not
    type = "text", // Input Type
    required = false,
    ...props // All other props
}, ref) => {
    // ref is passed by InputController as needed by react-hook-form

    // state for handing password type
    const [showPassword, setShowPassword] = useState(false);

    // handing to show/hide Password
    const handleClickShowPassword = () => {
      setShowPassword(!showPassword);
    };

    // handle onMouseDown for password
    const handleMouseDownPassword = (event) => {
      event.preventDefault();
    };

    // Slot Props
    // const slotProps = { // slot props in case, we need error to be absolute
    //   formHelperText: {
    //     sx: styles.mui_formHelperText // error-styling
    //   },
    //   input: { // Input Styling
    //     endAdornment: type === 'password' ? (
    //       <InputAdornment position="end">
    //         <IconButton
    //           aria-label="toggle password visibility"
    //           onClick={handleClickShowPassword}
    //           onMouseDown={handleMouseDownPassword}
    //           edge="end"
    //           tabIndex={-1}
    //         >
    //           {showPassword ? <VisibilityOff /> : <Visibility />}
    //         </IconButton>
    //       </InputAdornment>
    //     ) : (""),
    //   }
    // }
    // const maxDate = () => {
    //   const today = new Date();
    //   return today.toISOString().split("T")[0]; // Format YYYY-MM-DD
    // };

    // const maxDate = new Date().toISOString().split("T")[0]; // Format YYYY-MM-DD

    // Define slotProps
    const slotProps = {
      input: {
        ...(type === "password" && {
          endAdornment: (
            <InputAdornment position="end">
              <IconButton
                aria-label="toggle password visibility"
                onClick={handleClickShowPassword}
                onMouseDown={handleMouseDownPassword}
                edge="end"
                tabIndex={-1}
              >
                {showPassword ? <VisibilityOff /> : <Visibility />}
              </IconButton>
            </InputAdornment>
          ),
        }),
        ...(type === "date" && {
          // inputProps: {
          //   max: maxDate,
          //   // onInvalid: (e) => e.preventDefault(),
          // },
        }),
        ...(type === "number" && {
          inputProps: {
            onWheel: (e) => e.target.blur(),
            onKeyDown: (e) => {
              if (e.key === "ArrowUp" || e.key === "ArrowDown") {
                e.preventDefault(); // Disable default arrow key behavior
              }
            },
          },
        }),
      },
      formHelperText: {
        sx: styles.mui_formHelperText, // error-styling
      },
    };
    
    return (
      // Label and Input Wrapper
      <div className="flex flex-col gap-1 relative w-full">
        {/* Label optional */}
        {showLabel && (
          <FormLabel htmlFor={props.id || name} sx={styles.mui_label}>
            {label}{required && <span className="text-primaryHeading"> *</span>}
          </FormLabel>
        )}

        {/* Input Field */}
        <TextField
          {...props} // All other props
          fullWidth // Set Full Width
          name={name} // set name property (unique for each form)
          type={type === 'password' ? (showPassword ? 'text' : 'password') : type} // handing for password-type
          id={props.id || name} // id -> name(if not provided)
          aria-label={props.label || label} // aria-label property
          placeholder={props.placeholder || label} // placeholder
          error={props.error || error} // check is there any error?
          variant="outlined" // No outline
          autoComplete={"new-" + (name || props.id)} // Auto complete off
          slotProps={slotProps} // Slot Props
          sx={{ ...props.sx, ...styles.mui_input_sx}} // Styling
          helperText={props.helperText || helperText}
          inputRef={ref ? ref : null} // ref passed by InputController
          // InputProps={type === "date" ? { max: maxDate() } : undefined}
        />
      </div>
    );
});

// adds a readable name for the component in React DevTools and suppresses the ESLint warning.
InputField.displayName = "InputField";

export default React.memo(InputField);
